/**
*@Time : 2020/9/2 下午4:59
*@Author : Hejie Shao
*/
<template>
  <div class="warpper-container">
    <div class="product-warpper" ref="prodWarpper">
      <slot></slot>
    </div>
    <div class="dot-container">
      <div v-for="item in totalList" class="dot-item" :class="{active: item.isActive}" :key="item.id" @click="handleDot(item.id)"></div>
    </div>
    <div class="bottom-container" ref="bottomWrapper">
        <cpn-footer :icp=icps :text-color=textsColor />
    </div>
  </div>
</template>

<script>
import cpnFooter from "@/components/pc/footer"
export default {
  name: "productWarpper",
  data() {
    return {
      currentIndex: 0,
      isMoving: false,
      totalIndex: 0,
      totalList: [],
      icp:"浙ICP备20002569号",
      textColor:"#000000"
    }
  },
  computed:{
    isMac(){
      const ua = navigator.userAgent.toLowerCase();
      return /macintosh|mac os x/i.test(ua);
    },
    icps() {
      if(this.icp == null){
        return "浙ICP备20002569号"
      }
      return this.icp
    },
    textsColor(){
      if(this.icp == null){
        return "#000000"
      }
      return this.textColor
    }
  },
  components: {
    cpnFooter,
  },
  mounted() {
    this.totalIndex = this.$refs.prodWarpper.childElementCount - 1;
    for(let n=0; n < this.totalIndex+1; n++)
    {
      let obj = {
        id:n,
        isActive: false
      }
      if(n == 0)
        obj.isActive = true;
      this.totalList.push(obj);
    }
    document.addEventListener("wheel",this.handleScroll,true);
  },
  destroyed() {
    document.removeEventListener('wheel',this.handleScroll);
  },
  methods: {
    handleScroll(event){
      if(!this.isMoving) {
        this.isMoving = true;
        new Promise((resolve, reject) => {
          setTimeout(() => {
            resolve()
          }, 100)
        }).then(() => {
            if (event.deltaY < 0)
              this.currentIndex--;
            else
              this.currentIndex++;

          if (this.currentIndex < 0)
            this.currentIndex = 0;
          else if (this.currentIndex > this.totalIndex)
            this.currentIndex = this.totalIndex;
          this.moveWarpper(this.currentIndex);
        }).catch((error) => {
          this.isMoving = false;
        })
      }
      event.stopPropagation();
    },
    moveWarpper(index){
      let percent = -100;
      let move = index * percent;
      this.$refs.prodWarpper.style.transform = `translateY(${move}%)`;
      //this.isMoving = false;
      this.icp = "浙ICP备20002569号";
      this.textColor = "#000000";
      document.documentElement.style.setProperty('--dot-color', '#000000');
      if (index == 2) {
        // quwan. gray
        this.textColor = "#8B8C8D"
        document.documentElement.style.setProperty('--dot-color', '#8B8C8D');
      } else if (index == 0) {
        // drawfee. black
        this.textColor = "#000000"
        document.documentElement.style.setProperty('--dot-color', '#000000');
      }
      
      this.totalList.filter(a => {
        return a.isActive == true
      })[0].isActive = false

      this.totalList.filter(a => {
        return a.id == index
      })[0].isActive = true

      new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve()
        }, 1000)
      }).then(() => {
        this.isMoving = false;
      }).catch((error) => {
        this.isMoving = false;
      })
    },
    handleDot(id){
      if(this.isMoving)
        return
      this.isMoving = true;
      this.moveWarpper(id);
    }
  }
}
</script>

<style lang="scss">
@import "~@/assets/scss/globalFn.scss";
:root {
  --dot-color: #000000;
}
.warpper-container{
  position: relative;
  width: 100%;
  height: 100%;
  .product-warpper{
    position: relative;
    width: 100%;
    height: 100%;
    -webkit-transition: all .3s;
    transition: all .3s;
    transform: translateY(0%);
  }
  .dot-container{
    position: fixed;
    top: 50%;
    margin-top: cs(-300);
    right: cs(240);
    z-index: 10;
  }
  .dot-item{
    width: cs(12);
    height: cs(12);
    background-color: transparent;
    border-radius: 50%;
    border: cs(3) solid;
    border-color: var(--dot-color);
    margin-bottom: cs(40);
    cursor: pointer;
    &.active{
      width: cs(18);
      height: cs(18);
      border: 0;
      background-color: var(--dot-color);
    }
  }
}
</style>
